import PrimaryDefaultButton from '@/components/buttons/primary/DefaultButton';
import styled from 'styled-components';

const SecondaryInnerGlowButton = styled(PrimaryDefaultButton)`

`;


export default SecondaryInnerGlowButton;
